





























































































import { defineComponent, SetupContext, watch, onMounted } from '@vue/composition-api'
import BaseLayout from '@/components/_shared/BaseLayout.vue'
import Modal from '@/components/Modal/Modal.vue'
import Loading from '@/components/Loading/Loading.vue'
import MovieInfoBg from '@/components/MovieInfo/MovieInfoBg/MovieInfoBg.vue'
import MovieInfoLink from '@/components/MovieInfo/MovieInfoLink/MovieInfoLink.vue'
import MovieInfoBackDrop from '@/components/MovieInfo/MovieInfoBackDrop/MovieInfoBackDrop.vue'
import MovieInfoPoster from '@/components/MovieInfo/MovieInfoPoster/MovieInfoPoster.vue'
import MovieInfoHeading from '@/components/MovieInfo/MovieInfoHeading/MovieInfoHeading.vue'
import MovieInfoGenre from '@/components/MovieInfo/MovieInfoGenre/MovieInfoGenre.vue'
import MovieInfoAverage from '@/components/MovieInfo/MovieInfoAverage/MovieInfoAverage.vue'
import MovieInfoOverView from '@/components/MovieInfo/MovieInfoOverView/MovieInfoOverView.vue'
import MovieInfoRecommendation from '@/components/MovieInfo/MovieInfoRecommendation/MovieInfoRecommendation.vue'
import MovieList from '@/components/MovieList/MovieList.vue'
import MovieInfoSave from '@/components/MovieInfo/MovieInfoSave/MovieInfoSave.vue'
import { UseAPIComposition } from '@/composition/UseAPIComposition'
import { UseFetchDataComposition } from '@/composition/UseFetchDataComposition'
import { UseStorageComposition } from '@/composition/UseStorageComposition'
import { UseModalComposition } from '@/composition/UseModalComposition'
import { UsePresenterComposition } from '@/composition/UsePresenterComposition'
import { UseMoviePresenter, MoviePresenter } from '@/containers/Movie/UseMoviePresenter'

// ================================
// Component
// ================================
export default defineComponent({
  name: 'MovieContainer',
  components: {
    BaseLayout,
    MovieInfoAverage,
    MovieInfoBackDrop,
    MovieInfoBg,
    MovieInfoGenre,
    MovieInfoHeading,
    MovieInfoLink,
    MovieInfoOverView,
    MovieInfoPoster,
    MovieInfoRecommendation,
    MovieInfoSave,
    MovieList,
    Modal,
    Loading
  },
  setup (props, context: SetupContext) {
    const paramsId = context.root.$route.params.id
    const API = UseAPIComposition()
    const fetch = UseFetchDataComposition(context)
    const storage = UseStorageComposition(context)
    const modal = UseModalComposition()
    const presenter = UsePresenterComposition()

    /**
     * Movie情報を取得するFetchの初期化処理
     */
    async function initFetch (paramsId: string): Promise<void> {
      fetch.loading.value = true
      const fetchMovieDatas = await fetch.fetchMovieSelectedData(API.APIPathMovie(paramsId))
      const fetchVideoDatas = await fetch.fetchMovieVideosData(API.APIPathVideos(paramsId))
      const fetchRecommendDatas = await fetch.fetchMovieRecommendData(API.APIPathRecommendations(paramsId))
      const moviePresenter = UseMoviePresenter(fetchMovieDatas, fetchVideoDatas, fetchRecommendDatas)
      await presenter.presenterDatas<MoviePresenter>(moviePresenter)
      fetch.loading.value = false
      window.scrollTo(0, 0)
    }

    // ================================
    // LifeCycle
    // ================================
    onMounted(async () => {
      await initFetch(paramsId)
    })

    // ================================
    // Watch
    // ================================
    watch(() => context.root.$route, async (newRoute) => {
      await initFetch(newRoute.params.id)
    })

    return {
      API,
      paramsId,
      fetch,
      presenter,
      storage,
      modal
    }
  }
})
